import React from 'react';
import DemoNotAuthorized from "./DemoNotAuthorized/DemoNotAuthorized";
import DemoNotFilledUserData from "./DemoNotFilledUserData/DemoNotFilledUserData";

interface IProps {
    isCompletelyFilledDataUser: boolean,
    isAuth: boolean
}

const DemoDenied = ({isCompletelyFilledDataUser, isAuth}: IProps) => {


    if (!isAuth) {
       return <DemoNotAuthorized />
    }

    if (isAuth && !isCompletelyFilledDataUser) {
        return <DemoNotFilledUserData />
    }


    return (
        <div>
            Что-то пошло не так...
        </div>
    )
};

export default DemoDenied;